export default __webpack_public_path__ + "a96de1135bbca130898c9ee36ff41671.webp";